import { Toast } from 'atoms/triggerAtoms'
import hasCaseDetailAttribute from 'utils/caseDetails/hasCaseDetailAttribute'
import i18n from 'i18next'

const getMessageByCaseDetailType = (target: EventTarget | null) => {
  const defaultMessage = i18n.t('toast.editCaseDetailsSidebar')

  const isNotTarget = !(target instanceof HTMLElement)
  if (isNotTarget) return defaultMessage

  const attributeValue = target.getAttribute('data-template')
  const isNotHeader = !attributeValue?.endsWith('header')
  if (isNotHeader) return defaultMessage

  return i18n.t('toast.editCaseDetailsSidebarHeader')
}

export const remindUserToEditCaseDetailsInSidebar = ({
  editor,
  setToast,
}: {
  editor: Editor
  setToast: (toast: Toast) => void
}) => {
  if (!setToast) return

  let lastToastTime = 0
  const TOAST_COOLDOWN = 5000

  editor.on('click', (e: MouseEvent) => {
    const now = Date.now()
    // prevent spamming the user with toasts
    const isWithinCooldown = now - lastToastTime < TOAST_COOLDOWN
    if (isWithinCooldown) return

    const { target } = e
    const isCaseDetail = hasCaseDetailAttribute(target)

    if (isCaseDetail) {
      const message = getMessageByCaseDetailType(target)
      lastToastTime = now
      setToast({
        icon: 'info',
        text: message,
      })
    }
  })
}

export default remindUserToEditCaseDetailsInSidebar
